export class CampaignStateModel {
    campaignList!: {};
    activePage!: number;
    filterResult!: {};
}